const resource = '/v1/chats';

export default $axios => ({
  getList(projectId = null) {
    return $axios.get(`${resource}/channel`, {
      params: {
        project_id: projectId || ''
      }
    });
  },

  inviteUser(channelId, userId, projectId) {
    return $axios.post(`${resource}/channel/${channelId}/invite-user?project_id=${projectId || ''}`, {
      user_id: userId
    })
  },

  removeUser(channelId, userId) {
    return $axios.post(`${resource}/channel/${channelId}/remove-user`, {
      user_id: userId
    })
  },

  getUserById(userId) {
    return $axios.get(`${resource}/channel/get-user-by-id?user_id=${userId}`)
  },

  markSeen(channelId) {
    return $axios.post(`${resource}/channel/${channelId}/mark-seen`)
  },

  loadNewMessages(channelId, latestMessageId) {
    return $axios.get(`${resource}/channel/${channelId}/new-messages?latest_message_id=${latestMessageId || ''}`)
  },

  deleteMessage(messageId) {
    return $axios.delete(`${resource}/message/${messageId}`)
  },

  getUsersInChannel(channelId) {
    return $axios.get(`${resource}/channel/${channelId}/users`)
  },

  getUsersInProject(projectId = null) {
    return $axios.get(`${resource}/channel/list-user-project`, {
      params: {
        project_id: projectId || ''
      }
    })
  },

  createMessage(payload) {
    return $axios.post(`${resource}/message`, payload)
  },

  deleteChannel(channelId) {
    return $axios.delete(`${resource}/channel/${channelId}`)
  },

  getMessagesByChannelId(channel_id, last_id = null) {
    return $axios.get(`${resource}/message`, {
      params: {
        channel_id,
        last_id
      }
    })
  },

  createChannel(projectId, payload) {
    return $axios.post(`${resource}/channel?project_id=${projectId || ''}`, payload)
  },

  updateChannel(id, payload) {
    return $axios.put(`${resource}/channel/${id}`, payload)
  },

  loadMessageDelete(channelId, latestTimeMessage) {
    return $axios.get(
        `${resource}/channel/${channelId}/last-time-delete-message?last-time=${latestTimeMessage || ''}`
    )
  },
  updateRootUserChannel(channelId, payload) {
    return $axios.put(
        `${resource}/channel/${channelId}/update-role-user-channel`,
        payload
    )
  },
  sortChannel(payload) {
    return $axios.post(`${resource}/channel/sort-channel`, payload)
  }
});
